module.exports = __webpack_public_path__ + "img/IMG-20200229-WA0090.37b5825f.jpg";